/*
 * @Author: weiShu
 * @Date: 2025-12-29 15:40:44
 * @LastEditors: weiShu
 * @LastEditTime: 2025-12-30 08:33:48
 * @FilePath: \health-commission-new\src\router\index.js
 * @Description: 
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/tabbar'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
function isRouterNavigationFailure(err) {
    return err && (err._isRouter || err.name === 'NavigationDuplicated' || err.name === 'NavigationRedirected')
}
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => {
        if (isRouterNavigationFailure(err)) return err
        return Promise.reject(err)
    })
}
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
    if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
    return originalReplace.call(this, location).catch(err => {
        if (isRouterNavigationFailure(err)) return err
        return Promise.reject(err)
    })
}
const routes = [ 
    {
        path: '/login',
        name: 'login',
        component(receive) {
            require(['@/views/auth/login.vue'], receive)
        },
        meta: {
            title: '登录',
            public: true
        },
    },
    {
        path: '/register',
        name: 'register',
        component(receive) {
            require(['@/views/auth/register.vue'], receive)
        },
        meta: {
            title: '注册',
            public: true
        },
    },
    {
        path: '/forgot-password',
        name: 'forgotPassword',
        component(receive) {
            require(['@/views/auth/forgot-password.vue'], receive)
        },
        meta: {
            title: '找回密码',
            public: true
        },
    },
    {
        path: '/',
        component: Layout,
        redirect: '/evaluation',
        children: [
            {
                path: 'evaluation',
                name: 'evaluation',
                component(receive) {
                    require(['@/views/evaluation/index.vue'], receive)
                },
                meta: {
                    navIndex: 1,
                },
            }
        ],
    },
    {
        path: '/my',
        component: Layout,
        children: [
            {
                path: 'index',
                name: 'my',
                component(receive) {
                    require(['@/views/my/index.vue'], receive)
                },
                meta: {
                    navIndex: 2,
                },
            }
        ],
    },
    {
        path: '/exam-detail',
        name: 'examDetail',
        component(receive) {
            require(['@/views/evaluation/detail.vue'], receive)
        },
    },
    {
        path: '/profile',
        name: 'profile',
        component(receive) {
            require(['@/views/my/profile.vue'], receive)
        },
    },
    {
        path: '/exam-paper',
        name: 'examPaper',
        component(receive) {
            require(['@/views/evaluation/exam-paper.vue'], receive)
        },
    },
    {
        path: '/my/resultQuery',
        name: 'myResultQuery',
        component(receive) {
            require(['@/views/my/resultQuery.vue'], receive)
        },
    },
    {
        path: '/my/certificate',
        name: 'certificate',
        component(receive) {
            require(['@/views/my/certificate.vue'], receive)
        },
    },
    {
        path: '/my/exam-result-detail',
        name: 'examResultDetail',
        component(receive) {
            require(['@/views/my/exam-result-detail.vue'], receive)
        },
    },
]
const router = new VueRouter({
   // mode: 'history',
    routes
})

export default router
